import React, { useCallback } from 'react';
import useModuleData from '@wix/da-gruser-shared/pkg/hooks/useModuleData';
import { PapiModuleExhibitionist } from '@wix/da-papi-types';
import Grid from '../../../Grid';
import { DeviationLink } from '../../../Duperbrowse';
import { getTranslatedDeviationTitle } from '../../../DeviationViews/_helpers';
import DumboWithIcon from '../../../DeviationViews/DumboWithIcon/DumboWithIcon';
import { useTranslation } from 'react-i18next';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';

import s from './ExhibitionistGrid3x3.scss';

interface Props {
  moduleId: number;
}

const ExhibitionistGrid3x3: React.FC<Props> = ({ moduleId }) => {
  const { t } = useTranslation();
  const { moduleData } = useModuleData<PapiModuleExhibitionist>(moduleId);
  const { deviations } = moduleData;

  const renderItem = useCallback(
    ({ height, width, index, style }) => {
      const item = deviations[index];
      return (
        <div style={style} key={index}>
          <DeviationLink
            deviation={item}
            key={item.deviationId}
            title={getTranslatedDeviationTitle(item, t)}
          >
            <DumboWithIcon
              deviation={item}
              width={width}
              height={height}
              greenLikeCrop
              withSeoData={false}
            />
          </DeviationLink>
        </div>
      );
    },
    [deviations, t]
  );

  return (
    <div className={s['root']}>
      <Grid
        lazyloadFromContext
        enableScrollOptim={false}
        containerWidth={308}
        defaultSize={{
          desktop: { width: 308, height: 308 },
          mobile: { width: 308, height: 308 },
        }}
        cookieType={MeasuredCookieType.DEVIATION_SIDEBAR}
        maxRows={3}
        breakpoints={[
          {
            maxWidth: 600,
            elementsPerRow: 3,
            elementAspectRatio: 1,
          },
        ]}
        spacing={16}
        elementCount={deviations.length}
        renderElement={renderItem}
      />
    </div>
  );
};
ExhibitionistGrid3x3.displayName = 'ExhibitionistGrid3x3';

export default ExhibitionistGrid3x3;
